import _ from 'lodash';

export const convertObjectToQs = (json: any) => {
	return _(json)
		.map((item, index) => {
			if (_.isArray(item)) {
				if (item.length === 0) {
					return undefined;
				}

				if (item.length === 1 && _.toLower(item[0]) === 'all') {
					return undefined;
				}
				const piped = _.join(item, '|');
				return [index, piped];
			}
			if (
				!_.isUndefined(item) &&
				!_.isNull(item) &&
				item !== 'all' &&
				item !== 'any' &&
				item !== '' &&
				item
			) {
				return [index, item];
			}
			return undefined;
		})
		.compact()
		.map(item => `${item[0]}=${encodeURIComponent(item[1])}`)
		.join('&');
};
